import { isAfter, isBefore } from 'date-fns'
import i18n from '../i18n/i18n'
import { getLanguageBCP47 } from './i18n'

export const sortStringsAlphabetically = (
  strA = '',
  strB = '',
  dontLocaleCompare = false,
  locale = ''
): number => {
  const parsedA = strA.toLowerCase()
  const parsedB = strB.toLowerCase()

  if (!dontLocaleCompare) {
    if (parsedA.localeCompare != null) {
      return parsedA.localeCompare(
        parsedB,
        locale || getLanguageBCP47(i18n.language),
        {
          sensitivity: 'base',
          numeric: true,
        }
      )
    }
  }

  if (parsedA === parsedB) {
    return 0
  }

  return parsedA < parsedB ? -1 : 1
}

export const sortByDate = (
  dateStringA: string | Date,
  dateStringB: string | Date,
  desc = false
): number => {
  const dateA = new Date(dateStringA)
  const dateB = new Date(dateStringB)

  if (isBefore(dateA, dateB)) {
    return desc ? 1 : -1
  }

  if (isAfter(dateA, dateB)) {
    return desc ? -1 : 1
  }

  return 0
}

export const sortAdresses = (adressA = '', adressB = ''): number => {
  const adressASplit = adressA.split(' ')
  const adressBSplit = adressB.split(' ')

  if (adressASplit.length === 0 || adressBSplit.length === 0) {
    return 0
  }

  const alphabeticalOrder = sortStringsAlphabetically(
    adressASplit[0],
    adressBSplit[0]
  )
  if (alphabeticalOrder === 0) {
    try {
      const numA = adressASplit[adressASplit.length - 1]
      const numB = adressBSplit[adressBSplit.length - 1]
      return parseInt(numA, 10) - parseInt(numB, 10)
    } catch (error) {
      return sortStringsAlphabetically(adressA, adressB)
    }
  }
  return alphabeticalOrder
}
